<template>
  <app-transition>
    <Dialog class="InformMessage" :only-text="true" @close="handleClose">
      <div class="subscription-container">

        <!-- Already Subscribe confirmation (only when isSubscribe = true and not yet confirmed) -->
        <template v-if="isSubscribe && !showSubscriptionList">
          <v-row text-center>
            <v-col>
              <div class="SubscriptionPrice-title">
                {{ $t('dialogs.already_subscribed', { username: targetUsername }) }}
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-btn outlined block class="text-capitalize" @click="handleSelectMonth">
                {{ $t('dialogs.yes') }}
              </v-btn>
            </v-col>
            <v-col>
              <v-btn outlined block class="text-capitalize" @click="handleClose">
                {{ $t('dialogs.no') }}
              </v-btn>
            </v-col>
          </v-row>
        </template>

        <!-- Subscription list (shown when user clicks Yes OR isSubscribe = false) -->
        <template v-else>

            <v-row align="center" justify="center" no-gutters class="mt-6">
            <v-col>
              <div class="SubscriptionPrice-title">
                {{ $t('dialogs.gifted_subscription_desc', { username: targetUsername }) }}
              </div>
            </v-col>
          </v-row>
          <v-row
            align="center"
            justify="center"
            class="subscription-list mt-6"
            no-gutters
          >
            <v-col
              cols="4"
              v-for="(item, i) in subscriptions"
              :key="i"
            >
              <div
                @click="activeSubscription = i; model.months = item"
                :class="['select-subscription', { active: i === activeSubscription }]"
              >
                {{ formatSubscription(item) }}
              </div>
            </v-col>
          </v-row>

          <v-row justify="center" class="w-full">
            <v-col>
              <v-btn
                outlined
                block
                @click="save"
                :loading="$store.getters.loadingBtn(['setting', 'giftedSubscriptionBtn']) || loading"
              >
                {{ $t('components.subscription_menu.send_button') }}
              </v-btn>
            </v-col>
          </v-row>
        </template>

      </div>
    </Dialog>
  </app-transition>
</template>

<script>
import Radio from "@/components/app/form/Radio";
import GradientButton from "@/components/app/button/GradientButton";
import { CURRENCY_SYMBOL } from "@/configs/constants";
import VerifyDialog from "@/components/app/dialogs/VerifyDialog";
import InformDialog from "@/components/app/dialogs/InformDialog";
import { mapState } from "vuex";
import Dialog from "@/components/app/form/Dialog";

export default {
  name: "GiftSubscriptionDialog",
  data: () => ({
    model: {
      months: 3,
      is_gifted_subscription: true,
      already_subscribed: 0
    },
    subscriptions: [1, 3, 6, 12],
    activeSubscription: 1,
    hidden: true,
    isShowVerifyDialog: false,
    isShowCantSendFunds: false,
    currency: CURRENCY_SYMBOL,
    isSubscriptionNull: false,
    showSubscriptionList: false,
  }),
  props: {
    isShow: { 
        type: Boolean,
        default: false
    },
    hasRadio: {
        type: Boolean,
        default: true
    },
    blur: {
        type: Boolean,
        default: false
    },
    loading: {
        default: false
    },
    targetVerified: { 
        type: Boolean
    },
    targetUsername: { 
        type: String
    },
    isSubscribe: { 
        type: Boolean,
        default: false
    },
  },
  computed: {
    ...mapState({
      verified: (state) => state.user.user.data.verified,
      currentUser: (state) => state.user.user.data,
    }),
    canRequest() {
      return this.verified;
    },
    currentSubscription() {
      return this.subscriptions[this.activeSubscription];
    },
  },
  methods: {
    save() {
        if (!this.model.months || this.model.months === 0) {
            this.isSubscriptionNull = true;
            return;
        }

        if (!this.targetVerified) {
            this.isShowCantSendFunds = true;
            return;
        }

        const giftData = {
            months: this.currentSubscription,
            to: this.targetUsername,
            already_subscribed: this.model.already_subscribed,
        };

        this.$emit("save", giftData);
        this.model = { months: this.currentSubscription };
        this.$emit("close");
    },

    formatSubscription(months) {
        return `${months} Month${months > 1 ? "s" : ""}`;
    },

    handleSelectMonth() {
        this.model.already_subscribed = 1;
        this.showSubscriptionList = true;
    },

    handleClose() {
        this.$emit("close");
    },
  },
  components: {
    GradientButton,
    Radio,
    VerifyDialog,
    InformDialog,
    Dialog,
  },
};
</script>

<style scoped lang="scss">
@import "@/sass/modules/_variables";

.InformMessage {
  padding: 24px;

  &-title {
    font-size: 22px;
    font-weight: 600;
    text-align: center;
    margin-bottom: 20px;
    color: #222;
  }
}

.subscription-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.subscription-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
  margin-bottom: 24px;
}

.select-subscription {
  background: rgba(237, 237, 237, 0.3);
  border-radius: 8px;
  padding: 12px 20px;
  min-width: 80px;
  text-align: center;
  font-weight: 500;
  font-size: 15px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
  }

  &.active {
    background-image: $accent-background;
    color: white;
  }
}

@media (max-width: 600px) {
  .select-subscription {
    min-width: 65px;
    font-size: 14px;
    padding: 10px 12px;
  }
}
</style>
